module.exports = __webpack_public_path__ + "img/service_diagnose.2d94aa37.png";